const task = {
  TASK: 'TASK',
  TASKS: 'TASKS',
  SINGLE_TASKS: 'SINGLE_TASKS',
  UPDATE_TASKS: 'UPDATE_TASKS'
}

export { task }
